import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { CSVLink } from "react-csv";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



const Planmaster = () => {
  const [plans, setPlans] = useState([]);
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [rowData, setRowData] = useState([]);

   const [filteredPlans, setFilteredPlans] = useState([]);
  const [type, setType] = useState("all");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [newPlan, setNewPlan] = useState({
    name: '',
    category: '',
    validity_type: '',
    no_of_months: '',
    validity_days: '',
    validity: '', // New field
    entered_amount: '',
    discount: '',
    gst_percent: '',
    extrainfo: '',
    tag: '',
    is_active: true,
    cby: 'admin',
  });
  const [editingPlan, setEditingPlan] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});

  const handleEdit = (plan) => {
    setEditingPlan(plan);
    setNewPlan({
      ...plan,
      // Correctly set the validity type based on the plan's existing validity type
      validity_type: plan.validity_type == 'Days',  // Default to 'Days' if no validity type
      validity: plan.validity_type === 'Monthly' ? plan.no_of_months : plan.validity_days, // Set validity correctly based on type
    });
  };
  
  

  useEffect(() => {
    fetchPlans();
  }, []);


  useEffect(() => {
    filterPlans();
  }, [type]);


  useEffect(() => {
    if (alert.message) {
      const timer = setTimeout(() => setAlert({ message: "", type: "" }), 3000);
      return () => clearTimeout(timer);
    }
  }, [alert]);
  
  const filterPlans = () => {
    if (type === "all" || type === "select") {
      // Show all plans if "View All" or "வகையை தேர்வு செய்க" is selected
      setFilteredPlans(plans);
    } else {
      const filtered = plans.filter((plan) => plan.category === type);
      setFilteredPlans(filtered);
    }
  };


  const handleStatusEdit = (plan) => {
    setSelectedPlan(plan);
    setIsModalOpen(true);
  };
  
  
  
  

  const fetchPlans = async () => {
    try {
    //  const response = await axios.get('http://localhost:3036/plans');
      const response = await axios.get(`${API_BASE_URL}/plans`);
      // Add slNo based on the sorted order
      const sortedPlans = response.data.sort((a, b) => b.is_active - a.is_active); // Live users first
      const plansWithSlNo = sortedPlans.map((plan, index) => ({ ...plan, slNo: index + 1 }));
      
      setPlans(plansWithSlNo);
      setFilteredPlans(plansWithSlNo);
    } catch (error) {
      console.error('Error fetching plans:', error);
    }
  };
  



    useEffect(() => {
          document.title = 'Plan Master - Calendar Services';
        }, []);


  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewPlan((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  

  const confirmStatusChange = async () => {
    try {
      const loggedInUser = localStorage.getItem('username'); // Get the logged-in user
      const updatedStatus = selectedPlan.is_active === 1 ? 0 : 1; // Toggle status
  
      // Send update request to the backend
      // await axios.put(`http://localhost:3036/plans/${selectedPlan.id}/status`, {
        await axios.put(`${API_BASE_URL}/plans/${selectedPlan.id}/status`, {
      //   const response = await fetch(`${API_BASE_URL}/api/payments`, {


      // await axios.put(`${API_BASE_URL}/plans/${selectedPlan.id}/status`, {
        
        is_active: updatedStatus,
        mby: loggedInUser, // Include 'mby' in the payload
      });
  
      // Update local state
      const updatedPlans = plans.map((plan) =>
        plan.id === selectedPlan.id
          ? { ...plan, is_active: updatedStatus }
          : plan
      );
      const sortedUpdatedPlans = updatedPlans.sort((a, b) => b.is_active - a.is_active);
      const updatedPlansWithSlNo = sortedUpdatedPlans.map((plan, index) => ({
        ...plan,
        slNo: index + 1,
      }));
  
      setPlans(updatedPlansWithSlNo);
      setFilteredPlans(updatedPlansWithSlNo);
  
      setAlert({
        message: `Status updated to ${updatedStatus === 1 ? "Active" : "Inactive"}`,
        type: "success",
      });
  
      setIsModalOpen(false); // Close the modal
    } catch (error) {
      setAlert({
        message: error.response?.data?.message || "Error updating status",
        type: "error",
      });
    }
  };
  


  const closeModal = () => setIsModalOpen(false);



  const validateFields = () => {
    const errors = {};
    if (!newPlan.name) errors.name = 'Plan Name is required.';
    if (!newPlan.category) errors.category = 'Category is required.';
    if (!newPlan.validity_type) errors.validity_type = 'Validity Type is required.';
    if (newPlan.validity_type === 'Monthly' && !newPlan.validity) {
      errors.validity = 'Validity (Months) is required for Monthly plans.';
    }
    if (!newPlan.validity_days) errors.validity_days = 'Validity Days is required.';
    if (!newPlan.entered_amount) errors.entered_amount = 'Entered Amount is required.';
    if (!newPlan.gst_percent) errors.gst_percent = 'GST Percent is required.';
    return errors;
  };

  const handleCreateOrUpdate = async () => {
    const errors = validateFields();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    const loggedInUser  = localStorage.getItem("username");
    const typeValue = newPlan.validity_type === "Monthly" ? "Months" : "Days";

    // Ensure that `validity` is used when type is "Monthly"
    const finalPlanData = {
      ...newPlan, 
      type: typeValue, 
      cby: loggedInUser, 
      no_of_months: newPlan.validity_type === 'Monthly' ? newPlan.validity : 0, // Set no_of_months when it's a monthly plan
      validity: newPlan.validity_type === 'Monthly' ? 31 : newPlan.validity_days, // Default validity to 31 for monthly plans
    };

    try {
      if (editingPlan) {
        // Update existing plan
        const updatedPlan = { ...finalPlanData, mby: loggedInUser };
        await axios.put(`${API_BASE_URL}/plans/${editingPlan.id}`, updatedPlan);
        // Update local state with the modified plan
        setPlans((prevPlans) => prevPlans.map((plan) => (plan.id === editingPlan.id ? { ...plan, ...updatedPlan } : plan)));
        setFilteredPlans((prevFiltered) => prevFiltered.map((plan) => (plan.id === editingPlan.id ? { ...plan, ...updatedPlan } : plan)));
        setAlert({ message: "Plan updated successfully", type: "success" });
      } else {
        // Create new plan
        const newPlanWithCby = { ...finalPlanData, cby: loggedInUser };
        const response = await axios.post(`${API_BASE_URL}/plans`, newPlanWithCby);
        const createdPlan = { ...newPlanWithCby, id: response.data.insertId, is_active: newPlan.is_active ? 1 : 0 };
        setPlans((prevPlans) => [...prevPlans, createdPlan]);
        setFilteredPlans((prevFiltered) => [...prevFiltered, createdPlan]);
        setAlert({ message: "Plan created successfully", type: "success" });
      }

      // Reset form fields
      setNewPlan({
        name: "",
        category: "",
        validity_type: "",
        no_of_months: "",
        validity_days: "",
        validity: "", // Reset the validity
        entered_amount: "",
        discount: "",
        gst_percent: "",
        extrainfo: "",
        tag: "",
        is_active: true,
        cby: "",
      });
      setEditingPlan(null);
    } catch (error) {
      setAlert({
        message: error.response?.data?.message || "Error saving plan",
        type: "error",
      });
    }
  };


  


  

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this plan?')) {
      try {
        await axios.delete(`${API_BASE_URL}/plans/${id}`);
        setPlans((prevPlans) => prevPlans.filter((plan) => plan.id !== id));
      } catch (error) {
        console.error('Error deleting plan:', error);
      }
    }
  };

  const csvHeaders = [
    { label: "SlNo", key: "slNo" },
    { label: "Category", key: "category" },
    { label: "Plan Name", key: "name" },
    { label: "Type", key: "type" },
    { label: "No. of Months", key: "no_of_months" },
    { label: "Validity Days", key: "validity_days" },
    { label: "Plan Amount", key: "entered_amount" },
    { label: "Discount %", key: "discount" },
    { label: "GST %", key: "gst_percent" },
    { label: "GST Amount", key: "gstAmount" },
    { label: "Total Payable Amount", key: "totalPayableAmount" },
    { label: "Extra Information", key: "extrainfo" },
    { label: "Tag", key: "tag" },
    { label: "Status", key: "is_active" },
  ];



  const csvData = filteredPlans.map((plan) => {
    const amount = parseFloat(plan.entered_amount || 0);
    const gst = parseFloat(plan.gst_percent || 0);
    const discount = parseFloat(plan.discount || 0);
    const gstAmount = (amount * gst) / 100;
    const discountedAmount = amount - (amount * discount) / 100;
    const totalPayableAmount = discountedAmount + gstAmount;
  
    return {
      ...plan,
      gstAmount: gstAmount.toFixed(2),
      totalPayableAmount: totalPayableAmount.toFixed(2),
      is_active: plan.is_active === 1 ? "Active" : "Inactive",
    };
  });

  


  


  

  const columnDefs = [
    { headerName: 'S.No', field: 'slNo', flex: 1, sortable: true, filter: true,minWidth: 100 },
    {
      headerName: 'Actions', flex: 1, sortable: true, filter: true,minWidth: 100,
      cellRenderer: (params) => (
        <div className="flex space-x-1">
          <button
            onClick={() => handleEdit(params.data)}
            className="px-1 py-1 text-red-500 rounded"
          >
            Edit
          </button>
          <button
            onClick={() => handleDelete(params.data.id)}
            className="px-3 py-1 text-blue-500 rounded"
          >
            Delete
          </button>
        </div>
      ),
    },
     {
      headerName: 'Status',
      field: 'is_active',
      flex: 1,minWidth: 110,
      valueFormatter: (params) => (params.value === 1 ? 'Active' : 'Inactive'),
      cellRenderer: (params) => (
        <div className="flex items-center space-x-2">
          <span style={{ color: params.value === 1 ? 'green' : 'red', fontWeight: 'bold' }}>
            {params.value === 1 ? 'Active' : 'Inactive'}
          </span>
          <button
            className="text-blue-600 hover:underline"
            onClick={() => handleStatusEdit(params.data)}
          >
            🖉
          </button>
        </div>
      ),
    },
    { headerName: 'Category', field: 'category', flex: 2, sortable: true,minWidth: 150, filter: true },
    { headerName: 'Plan Name', field: 'name', flex: 2, sortable: true, filter: true,minWidth: 150 },
    { headerName: 'Type', field: 'type', flex: 1, sortable: true, filter: true,minWidth: 120 },
    {
      headerName: 'No. of Months',
      field: 'no_of_months',
      flex: 1,
      sortable: true,
      filter: true,
      minWidth: 150,
      valueGetter: (params) => {
        return params.data.no_of_months || 0; // Ensure it returns a number
      },
    },
    {
      headerName: 'Validity Days',
      field: 'validity_days',
      flex: 1,
      sortable: true,
      filter: true,
      minWidth: 140,
      valueGetter: (params) => {
        return params.data.validity_days || 0; // Ensure it returns a number
      },
    },
    {
      headerName: 'Plan Amount',
      field: 'entered_amount',
      flex: 1,
      sortable: true,
      filter: true,
      minWidth: 140,
      valueGetter: (params) => {
        return params.data.entered_amount || 0; // Ensure it returns a number
      },
    },
    { headerName: 'Discount %', field: 'discount', flex: 1, sortable: true, filter: true,minWidth: 130 },
    
    { headerName: 'GST', field: 'gst_percent', flex: 1, sortable: true, filter: true,minWidth: 120 },
    {
      headerName: 'GST Amount',minWidth: 140,
      valueGetter: (params) => {
        const amount = parseFloat(params.data.entered_amount || 0);
        const gst = parseFloat(params.data.gst_percent || 0);
        return ((amount * gst) / 100).toFixed(2);
      },
      flex: 1,
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Total Payable Amount',minWidth: 190,
      valueGetter: (params) => {
        const amount = parseFloat(params.data.entered_amount || 0);
        const gst = parseFloat(params.data.gst_percent || 0);
        const discount = parseFloat(params.data.discount || 0);
        const gstAmount = (amount * gst) / 100;
        const discountedAmount = amount - (amount * discount) / 100;
        return (discountedAmount + gstAmount).toFixed(2);
      },
      flex: 1,
      sortable: true,
      filter: true,
    },
    { headerName: 'Offer Starts On', field: 'offer_start_date', flex: 2, sortable: true, filter: true,minWidth: 190 },
    { headerName: 'Offer Ends On', field: 'offer_end_date', flex: 2, sortable: true, filter: true,minWidth: 190 },
   
        { headerName: 'Extra Information', field: 'extrainfo', flex: 2, sortable: true, filter: true,minWidth: 190 },
    { headerName: 'Tag', field: 'tag', flex: 2, sortable: true, filter: true,minWidth: 120 },
  ];
  
  return (
    <div className="bg-gray-100 p-6">
       {alert.message && (
        <div
          className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg z-50 ${
            alert.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          <span>{alert.message}</span>
        </div>
      )}
      <div className=" max-w-7xl container mx-auto p-6">
        <h1 className="text-2xl font-bold text-center bg-blue-600 text-white py-3">Plan Master</h1>
        <div className="bg-white shadow p-6 rounded mb-6">
          <h2 className="text-lg font-semibold mb-4">
            {editingPlan ? 'Edit Plan' : 'Create New Plan'}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
  <div>
    <input
      type="text"
      name="name"
      placeholder="Plan Name *"
      value={newPlan.name}
      onChange={handleInputChange}
      className="border rounded px-3 py-2 w-full mb-1"
    />
    {validationErrors.name && (
      <p className="text-red-500 text-sm mt-1">{validationErrors.name}</p>
    )}
  </div>

  <div>
    <select
      name="category"
      value={newPlan.category}
      onChange={handleInputChange}
      className="border rounded px-3 py-2 w-full mb-1"
    >
      <option value="">Select Category</option>
      <option value="ஜோதிடர்">ஜோதிடர்</option>
      <option value="ஐயர்">ஐயர்</option>
      <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
      <option value="எண்கணிதம்">எண்கணிதம்</option>
      <option value="விபூதி தயாரிப்பவர் - Others">விபூதி தயாரிப்பவர் - Others</option>
      <option value="ஆன்மீக சொற்பொழிவாளர் - Others">ஆன்மீக சொற்பொழிவாளர் - Others</option>
    </select>
    {validationErrors.category && (
      <p className="text-red-500 text-sm mt-1">{validationErrors.category}</p>
    )}
  </div>

  <div>
    <select
      name="validity_type"
      value={newPlan.validity_type}
      onChange={handleInputChange}
      className="border rounded px-3 py-2 w-full mb-1"
    >
      <option value="">Select Plan Validity</option>
      <option value="Days">Days</option>
      <option value="Monthly">Months</option>
    </select>
    {validationErrors.validity_type && (
      <p className="text-red-500 text-sm mt-1">{validationErrors.validity_type}</p>
    )}
  </div>

  {newPlan.validity_type === 'Monthly' && (
    <div>
      <input
        type="number"
        name="validity"
        placeholder="Validity (Months)"
        value={newPlan.no_of_months}
        onChange={handleInputChange}
        className="border rounded px-3 py-2 w-full mb-1"
      />
      {validationErrors.no_of_months && (
        <p className="text-red-500 text-sm mt-1">{validationErrors.no_of_months}</p>
      )}
    </div>
  )}

  <div>
    <input
      type="number"
      name="validity_days"
      placeholder="Validity Days *"
      value={newPlan.validity_days}
      onChange={handleInputChange}
      className="border rounded px-3 py-2 w-full mb-1"
    />
    {validationErrors.validity_days && (
      <p className="text-red-500 text-sm mt-1">{validationErrors.validity_days}</p>
    )}
  </div>

  <div>
    <input
      type="number"
      name="entered_amount"
      placeholder="Enter Amount *"
      value={newPlan.entered_amount}
      onChange={handleInputChange}
      className="border rounded px-3 py-2 w-full mb-1"
    />
    {validationErrors.entered_amount && (
      <p className="text-red-500 text-sm mt-1">{validationErrors.entered_amount}</p>
    )}
  </div>

  <div>
    <input
      type="number"
      name="discount"
      placeholder="Discount % (For Offer Plans Only)"
      value={newPlan.discount}
      onChange={handleInputChange}
      className="border rounded px-3 py-2 w-full mb-1"
    />
  </div>

  <div>
    <input
      type="number"
      name="gst_percent"
      placeholder="GST % *"
      value={newPlan.gst_percent}
      onChange={handleInputChange}
      className="border rounded px-3 py-2 w-full mb-1"
    />
    {validationErrors.gst_percent && (
      <p className="text-red-500 text-sm mt-1">{validationErrors.gst_percent}</p>
    )}
  </div>

  <div>
    <input
      type="text"
      name="extrainfo"
      placeholder="Additional Info"
      value={newPlan.extrainfo}
      onChange={handleInputChange}
      className="border rounded px-3 py-2 w-full mb-1"
    />
  </div>

  <div>
    <input
      type="text"
      name="tag"
      placeholder="Tag"
      value={newPlan.tag}
      onChange={handleInputChange}
      className="border rounded px-3 py-2 w-full mb-1"
    />
  </div>
</div>

          <div className="mt-4 flex items-center space-x-4">
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                name="is_active"
                checked={newPlan.is_active}
                onChange={(e) =>
                  handleInputChange({
                    target: {
                      name: 'is_active',
                      value: e.target.checked,
                    },
                  })
                }
                className="h-5 w-5"
              />
              <span>Is Active</span>
            </label>
            <button
              onClick={handleCreateOrUpdate}
              className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
            >
              {editingPlan ? 'Update Plan' : 'Create Plan'}
            </button>
          </div>
          <p className="mt-2 text-sm text-blue-800">
  Note*: Only for offer plans, please enter discount %. Otherwise leave blank.
</p>
        </div>
        <div className="max-w-6xl mx-auto mt-9 bg-white shadow-md rounded mb-10">
        <div className="p-9">
        <h2 className="text-xl font-bold text-center mb-1">Manage Plans</h2>
        <div className="flex justify-between items-center mb-6">
  <select
    id="type"
    value={type}
    onChange={(e) => setType(e.target.value)}
    className="border border-gray-300 rounded-md p-2"
  >
    <option value="select">வகையை தேர்வு செய்க</option>
    <option value="all">--View All--</option>
    <option value="வாஸ்து நிபுணர்">வாஸ்து நிபுணர்</option>
    <option value="மற்ற ஆன்மிக சேவைகள்">மற்ற ஆன்மிக சேவைகள்</option>
    <option value="ஜோதிடர்">ஜோதிடர்</option>
    <option value="ஐயர்">ஐயர்</option>
    <option value="எண்கணிதம்">எண்கணிதம்</option>
    <option value="விபூதி தயாரிப்பவர்- others">விபூதி தயாரிப்பவர்- others</option>
    <option value="ஆன்மீக சொற்பொழிவாளர்- others">ஆன்மீக சொற்பொழிவாளர்- others</option>
    <option value="திருவிழா அலங்காரம் செய்பவர்- others">திருவிழா அலங்காரம் செய்பவர்- others</option>
    <option value="சிற்பி / ஸ்தபதி- others">சிற்பி / ஸ்தபதி- others</option>
  </select>

  <CSVLink
    data={csvData}
    headers={csvHeaders}
    filename="PlanMaster_Export.csv"
    className="bg-green-500 text-white px-4 py-2 rounded-md"
  >
    Export to Excel
  </CSVLink>
</div>

          <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
      

          <AgGridReact  rowData={filteredPlans} columnDefs={columnDefs}  
                        defaultColDef={{ sortable: true, filter: true, editable:true }}
                        pagination={true} />
        </div>
      </div>
      </div>
    </div>
       {/* Confirmation Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg text-center">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to change the status?
            </p>
            <div className="flex justify-center space-x-4">
              <button
                className="px-4 py-2 bg-green-500 text-white rounded"
                onClick={confirmStatusChange}
              >
                Yes
              </button>
              <button
                className="px-4 py-2 bg-red-500 text-white rounded"
                onClick={closeModal}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Planmaster;
